import React from 'react'

const ScrollPreview = () => {
    return (
        <div>ScrollPreview</div>
    )
}
    
export default ScrollPreview;